export * from "@/components/base-ui/scroll-area";
